/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  Result,
  ResultOfThirdPartiesViewModel,
  ResultOfThirdPartyViewModel,
  ThirdPartiesViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfThirdPartiesViewModelFromJSON,
    ResultOfThirdPartiesViewModelToJSON,
    ResultOfThirdPartyViewModelFromJSON,
    ResultOfThirdPartyViewModelToJSON,
    ThirdPartiesViewModelFromJSON,
    ThirdPartiesViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ThirdPartiesDeleteRequest {
    productThirdPartyRelationId: number;
    proposalId?: number;
    isComplete?: boolean;
}

export interface ThirdPartiesDeleteAllRequest {
    proposalId: number;
    thirdPartyRelationType?: ThirdPartiesDeleteAllThirdPartyRelationTypeEnum;
    isComplete?: boolean;
}

export interface ThirdPartiesGetRequest {
    proposalId: number;
}

export interface ThirdPartiesGetThirdPartyRequest {
    partyId: number;
    thirdPartyRelationType?: ThirdPartiesGetThirdPartyThirdPartyRelationTypeEnum;
}

export interface ThirdPartiesPostRequest {
    proposalId: number;
    thirdPartiesViewModel: ThirdPartiesViewModel;
}

/**
 * 
 */
export class ThirdPartiesApi extends runtime.BaseAPI {

    /**
     * Deletes a specific product third party relation.
     */
    async thirdPartiesDeleteRaw(requestParameters: ThirdPartiesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.productThirdPartyRelationId === null || requestParameters.productThirdPartyRelationId === undefined) {
            throw new runtime.RequiredError('productThirdPartyRelationId','Required parameter requestParameters.productThirdPartyRelationId was null or undefined when calling thirdPartiesDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.proposalId !== undefined) {
            queryParameters['proposalId'] = requestParameters.proposalId;
        }

        if (requestParameters.isComplete !== undefined) {
            queryParameters['isComplete'] = requestParameters.isComplete;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/third-parties/delete/{productThirdPartyRelationId}`.replace(`{${"productThirdPartyRelationId"}}`, encodeURIComponent(String(requestParameters.productThirdPartyRelationId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes a specific product third party relation.
     */
    async thirdPartiesDelete(requestParameters: ThirdPartiesDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.thirdPartiesDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes all product third party relations of a specific third party relation type on a proposal.
     */
    async thirdPartiesDeleteAllRaw(requestParameters: ThirdPartiesDeleteAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling thirdPartiesDeleteAll.');
        }

        const queryParameters: any = {};

        if (requestParameters.thirdPartyRelationType !== undefined) {
            queryParameters['thirdPartyRelationType'] = requestParameters.thirdPartyRelationType;
        }

        if (requestParameters.isComplete !== undefined) {
            queryParameters['isComplete'] = requestParameters.isComplete;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/third-parties/delete-all/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Deletes all product third party relations of a specific third party relation type on a proposal.
     */
    async thirdPartiesDeleteAll(requestParameters: ThirdPartiesDeleteAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.thirdPartiesDeleteAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the proposal\'s third parties.
     */
    async thirdPartiesGetRaw(requestParameters: ThirdPartiesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfThirdPartiesViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling thirdPartiesGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/third-parties/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfThirdPartiesViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the proposal\'s third parties.
     */
    async thirdPartiesGet(requestParameters: ThirdPartiesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfThirdPartiesViewModel> {
        const response = await this.thirdPartiesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a specific third party.
     */
    async thirdPartiesGetThirdPartyRaw(requestParameters: ThirdPartiesGetThirdPartyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfThirdPartyViewModel>> {
        if (requestParameters.partyId === null || requestParameters.partyId === undefined) {
            throw new runtime.RequiredError('partyId','Required parameter requestParameters.partyId was null or undefined when calling thirdPartiesGetThirdParty.');
        }

        const queryParameters: any = {};

        if (requestParameters.thirdPartyRelationType !== undefined) {
            queryParameters['thirdPartyRelationType'] = requestParameters.thirdPartyRelationType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/third-parties/third-party/{partyId}`.replace(`{${"partyId"}}`, encodeURIComponent(String(requestParameters.partyId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfThirdPartyViewModelFromJSON(jsonValue));
    }

    /**
     * Gets a specific third party.
     */
    async thirdPartiesGetThirdParty(requestParameters: ThirdPartiesGetThirdPartyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfThirdPartyViewModel> {
        const response = await this.thirdPartiesGetThirdPartyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the specified proposal identifier.
     */
    async thirdPartiesPostRaw(requestParameters: ThirdPartiesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling thirdPartiesPost.');
        }

        if (requestParameters.thirdPartiesViewModel === null || requestParameters.thirdPartiesViewModel === undefined) {
            throw new runtime.RequiredError('thirdPartiesViewModel','Required parameter requestParameters.thirdPartiesViewModel was null or undefined when calling thirdPartiesPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/third-parties/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThirdPartiesViewModelToJSON(requestParameters.thirdPartiesViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     * Posts the specified proposal identifier.
     */
    async thirdPartiesPost(requestParameters: ThirdPartiesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.thirdPartiesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ThirdPartiesDeleteAllThirdPartyRelationTypeEnum = {
    Bene: 'BENE',
    Nominee: 'NOMINEE',
    Altben: 'ALTBEN',
    Dependt: 'DEPENDT',
    Owner: 'OWNER',
    Lifeass: 'LIFEASS',
    Addressee: 'ADDRESSEE',
    Guardian: 'GUARDIAN',
    Pwrattrny: 'PWRATTRNY',
    Executor: 'EXECUTOR',
    Plrep: 'PLREP',
    Preprov: 'PREPROV',
    Payer: 'PAYER',
    Payee: 'PAYEE',
    Trust: 'TRUST',
    Assignee: 'ASSIGNEE',
    Assignor: 'ASSIGNOR',
    Loa: 'LOA',
    Curatorbon: 'CURATORBON',
    Parent: 'PARENT',
    Ntlgu: 'NTLGU',
    Lglgu: 'LGLGU',
    Cessionary: 'CESSIONARY',
    Nomforown: 'NOMFOROWN',
    Principal: 'PRINCIPAL'
} as const;
export type ThirdPartiesDeleteAllThirdPartyRelationTypeEnum = typeof ThirdPartiesDeleteAllThirdPartyRelationTypeEnum[keyof typeof ThirdPartiesDeleteAllThirdPartyRelationTypeEnum];
/**
 * @export
 */
export const ThirdPartiesGetThirdPartyThirdPartyRelationTypeEnum = {
    Bene: 'BENE',
    Nominee: 'NOMINEE',
    Altben: 'ALTBEN',
    Dependt: 'DEPENDT',
    Owner: 'OWNER',
    Lifeass: 'LIFEASS',
    Addressee: 'ADDRESSEE',
    Guardian: 'GUARDIAN',
    Pwrattrny: 'PWRATTRNY',
    Executor: 'EXECUTOR',
    Plrep: 'PLREP',
    Preprov: 'PREPROV',
    Payer: 'PAYER',
    Payee: 'PAYEE',
    Trust: 'TRUST',
    Assignee: 'ASSIGNEE',
    Assignor: 'ASSIGNOR',
    Loa: 'LOA',
    Curatorbon: 'CURATORBON',
    Parent: 'PARENT',
    Ntlgu: 'NTLGU',
    Lglgu: 'LGLGU',
    Cessionary: 'CESSIONARY',
    Nomforown: 'NOMFOROWN',
    Principal: 'PRINCIPAL'
} as const;
export type ThirdPartiesGetThirdPartyThirdPartyRelationTypeEnum = typeof ThirdPartiesGetThirdPartyThirdPartyRelationTypeEnum[keyof typeof ThirdPartiesGetThirdPartyThirdPartyRelationTypeEnum];
